import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { PAGE_NAMES } from '../../../core/helpers/constants';
import { IPermission } from '../../../core/models/auth.models';
import { ICompany } from '../../../core/models/datafeed.models';
import { InstanceService } from '../../../core/instance/instance.service';
import { AppService } from '../../../store/app.service';
import { CompanyApiService } from '../company.apiservice';
import { CompanyService } from '../company.service';
import { ISearch } from '../../../core/models/search.model';

@Component({
  selector: 'app-company-main',
  templateUrl: './company-main.component.html',
  styleUrls: ['./company-main.component.scss'],
})
export class CompanyMainComponent implements OnInit, OnDestroy {
  doWhat: IPermission = {} as IPermission;
  columns = [
    { title: 'COMPANY_NAME', field: 'name', sortable: true, searchable: true, translate: true },
    { title: 'CONTACT_NAME', field: 'companyOwnerDisplayName', sortable: true, searchable: true, translate: true },
    { title: 'CONTACT_EMAIL', field: 'companyOwner.email', searchable: true, sortable: true, translate: true },
    { title: 'CONTACT_PHONE', field: 'companyOwner.phone', searchable: true, translate: true },
  ];
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  companiesData: Array<ICompany>
  savedSearchId: string | null = null;
  companySavedSearches: ISearch[] = [];
  selectedSavedSearchId: string | null = null;

  constructor(
    private appService: AppService,
    private companyApiService: CompanyApiService,
    private route: ActivatedRoute,
    private compService: CompanyService,
    public instance: InstanceService,
  ) {
    this.companiesData = new Array<ICompany>();
  }

  private formatContactName(firstName?: string, lastName?: string): string {
    const first = String(firstName ?? '').trim();
    const last = String(lastName ?? '').trim();

    if (!first && !last) return '';
    return (this.instance.isLastNameFirst ? `${last} ${first}` : `${first} ${last}`).trim();
  }

  ngOnInit(): void {

    this.appService.setPageTitle$('COMPANIES');
    this.doWhat = this.appService.getUserRolesForPage(PAGE_NAMES.Companies);
    this.appService.getAllCompanies$()
      .pipe(takeUntil(this.destroyed$)
      )
      .subscribe((response: Array<ICompany>) => {
        this.companiesData = (response ?? []).map((c: any) => ({
          ...c,
          companyOwnerDisplayName: this.formatContactName(c?.companyOwner?.firstName, c?.companyOwner?.lastName),
        }));
      });
    this.savedSearchId = this.route.snapshot.queryParams['savedsearchid'] || null;
    this.loadSavedSearches();
    this.appService.fetchAllCompanies(this.savedSearchId);
  }

  private loadSavedSearches() {
    this.appService.fetchSearches();
    this.appService.getAllSearches$()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((searches: ISearch[]) => {
        this.companySavedSearches = (searches || [])
          .filter(search => search.resultType?.toLowerCase() === 'company');
        this.selectedSavedSearchId = this.companySavedSearches.some(search => search.id === this.savedSearchId)
          ? this.savedSearchId
          : null;
      });
  }

  onSavedSearchChange(savedSearchId: string | null) {
    this.selectedSavedSearchId = savedSearchId || null;
    this.savedSearchId = savedSearchId || '';
    this.appService.fetchAllCompanies(this.savedSearchId);
  }

  editRow(evt: any) {
    this.compService.openEditCompanyModal(evt)
  }

  onAddNew() {
    this.compService.openEditCompanyModal({ id: null })
  }

  deleteRows(evt: any) {
    this.companyApiService.deleteCompany(evt)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        this.appService.fetchAllCompanies(this.savedSearchId);
      })

  }
  onClientRowClick(evt: any) {
    this.compService.openEditCompanyModal(evt)
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
